import * as t from '../constants/ActionTypes';
import { handleActions } from 'redux-actions';

const initialRequest = {
  limit: 10,
  orderField: 'date_update',
  orderDirection: 'DESC',
};

const typeFilters = ['new', 'viewAction', 'orderField', 'blackList'];
const newOrderFields = ['visit_day', 'visit_week', 'visit_month'];

const isTypeFilter = ({ object, key }) => {
  if (object[key]) {
    if (typeFilters.includes(key)) {
      if (key === 'orderField') {
        if (newOrderFields.includes(object[key])) return true;
        return false;
      }
      return true;
    }
  }
  return false;
};

const getIsOrderFieldTypeFilter = ({ object, key }) => {
  if (object[key]) {
    if (typeFilters.includes(key)) {
      if (key === 'orderField') {
        if (newOrderFields.includes(object[key])) return true;
        return false;
      }
      return false;
    }
  }
  return false;
};

const typeFiltersInitialRequest = {
  // new: false,
  // viewAction: false,
  orderField: initialRequest.initialRequest,
  // blackList: false,
};

const initialState = {
  request: initialRequest,
  autocomplete: {
    buildings: [],
    streets: [],
    regions: [],
    subregions: [],
  },
  value: '',
  autocompleteError: [],
  isLoading: false,
  isSearchModalOpen: false,
  hasFilters: false,
  isFetched: false,
  parking: false,
  elevator: false,
  childrenArea: false,
  concierge: false,
  recreationZone: false,
  pool: false,
  houseTerritory: false,
  isTypeFilters: false,
  isOrderFieldTypeFilter: false,
};

export default handleActions(
  {
    [`${t.SET_SEARCH_VALUE}`]: (state, { payload }) => ({
      ...state,
      value: payload,
    }),
    [`${t.FORCED_SEARCH_CHANGE}`]: (state, { payload }) => ({
      ...state,
      request: {
        ...state.request,
        query: payload,
      },
    }),
    UPDATE_PROFILE_REGION_OK: (state, { payload }) => ({
      ...state,
      request: {
        ...state.request,
      },
    }),
    [`${t.CHANGE_FILTERS}`]: (state, { payload, reset, withoutTypeFilters }) => {
      // FIXME Refactor whole search logic !!!
      let newPayload = {};
      if (reset) {
        newPayload = payload && { ...initialRequest, ...payload };
      } else {
        newPayload = payload && { ...state.request, ...payload };
      }
      if (withoutTypeFilters) {
        newPayload = { ...newPayload, ...typeFiltersInitialRequest };
      }
      const isOrderFieldTypeFilter =
        payload &&
        Object.keys(newPayload).some((k) =>
          getIsOrderFieldTypeFilter({ object: newPayload, key: k })
        );
      if (payload && isOrderFieldTypeFilter) {
        newPayload.orderDirection = 'DESC';
        newPayload.limit = 25;
      }
      if (payload && !newPayload.orderField && !isOrderFieldTypeFilter) {
        newPayload.orderField = 'date_update';
        newPayload.orderDirection = 'DESC';
      }
      return {
        ...state,
        request: payload ? newPayload : initialRequest,
        hasFilters: !!(
          payload &&
          Object.keys(newPayload).filter((k) => {
            if (k === 'typeId') {
              return false;
            }
            return newPayload[k] && !initialRequest[k];
          }).length
        ),
        isTypeFilters:
          payload &&
          Object.keys(newPayload).some((k) => isTypeFilter({ object: newPayload, key: k })),
        isOrderFieldTypeFilter,
      };
    },
    [`${t.SET_SEARCH_MODAL_STATE}`]: (state, { payload }) => ({
      ...state,
      isSearchModalOpen: payload,
    }),
    [`${t.LOAD_AUTOCOMPLETE}_FETCHING`]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      isFetched: false,
    }),
    [`${t.LOAD_AUTOCOMPLETE}_SUCCESS`]: (state, { payload }) => {
      const { buildings, regions, subregions, streets } = payload.data;
      return {
        ...state,
        autocomplete: {
          buildings: buildings ? buildings.slice(0, 15) : [],
          subregions: subregions ? subregions.slice(0, 5) : [],
          regions: regions ? regions.slice(0, 5) : [],
          streets: streets ? streets.slice(0, 15) : [],
        },
        isLoading: false,
        isFetched: true,
      };
    },
    [`${t.LOAD_AUTOCOMPLETE}_ERROR`]: (state, { payload }) => ({
      ...state,
      autocompleteError: [...payload],
      isLoading: false,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/search.js